import * as tsx from 'vue-tsx-support';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { HBtn } from '~/components';
import { HotelBrandDetail } from '~/schemes';

export interface MyHotelLucyPromisesProps {
  brandPromises?: HotelBrandDetail['brandPromises'];
}

export interface MyHotelLucyPromisesEmits {}

export interface MyHotelLucyPromisesScopedSlots {}

@Component<MyHotelLucyPromisesRef>({
  name: 'MyHotelLucyPromises',
  render() {
    // 1つ目の改行は不要なので削除
    const title =
      this.brandPromises && this.brandPromises.title.replace(/\n/, '');

    const subtitle = this.brandPromises && this.brandPromises.subtitle;

    const promises =
      (this.brandPromises && this.brandPromises.promises.map((p) => p.title)) ||
      [];

    return (
      <div staticClass="my-hotel-lucy-promises">
        <div staticClass="my-hotel-lucy-promises__inner">
          <span staticClass="my-hotel-lucy-promises__lead">{subtitle}</span>
          <h2 staticClass="my-hotel-lucy-promises__title">{title}</h2>

          <div staticClass="my-hotel-lucy-promises__container">
            <img
              staticClass="my-hotel-lucy-promises__illustration"
              src={this.$res.img('/brands/lucy/promises/promise-1.png')}
              alt=""
            />
            <div staticClass="my-hotel-lucy-promises__items">
              {promises.map((promise) => (
                <div staticClass="my-hotel-lucy-promises__item">
                  <img
                    staticClass="my-hotel-lucy-promises__icon"
                    src={this.$res.img('/brands/lucy/icon-thumbs-up.svg')}
                    alt=""
                  />
                  <span staticClass="my-hotel-lucy-promises__text">
                    {promise}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <HBtn
            staticClass="my-hotel-lucy-promises__btn"
            prependStack
            href={`/${this.$language.current}/brands/lucy/#brandPromises`}>
            詳しく見る
          </HBtn>
        </div>
      </div>
    );
  },
})
export default class MyHotelLucyPromisesRef
  extends Vue
  implements MyHotelLucyPromisesProps {
  @Prop({ type: Object })
  readonly brandPromises?: HotelBrandDetail['brandPromises'];
}

export const TypedMyHotelLucyPromises = tsx
  .ofType<
    MyHotelLucyPromisesProps,
    MyHotelLucyPromisesEmits,
    MyHotelLucyPromisesScopedSlots
  >()
  .convert(MyHotelLucyPromisesRef);
